import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import { memo } from "react";
import styles from "./styles.module.scss";

function HomePagePlaceHolder() {
  return (

    <>

      <div style={{ paddingTop: "calc(0.5 * var(--safari-root-font, 10px))", position: "relative" }}>
        <div className={styles.heading}>
          <LoaderSkeleton />
        </div>

        <div className="m-b-10">
          <LoaderSkeleton count={9} height={150} gridView />
        </div>

        <div className={styles.action_grid_container}>
          <div className="d-flex flex-column" style={{ width: "24%" }}>
            <LoaderSkeleton count={2} height={237} />
          </div>

          <LoaderSkeleton count={1} />

          <div className="d-flex flex-column" style={{ width: "24%" }}>
            <LoaderSkeleton count={2} height={237} />
          </div>

        </div>
        <div className="m-b-30">
          <LoaderSkeleton count={1} height={30} className="m-b-10" />
          <div className="d-flex" style={{ width: "100%", gap: "calc(2 * var(--safari-root-font, 10px))" }}>
            <div style={{ width: "50%" }}>
              <LoaderSkeleton count={1} height={400} />
            </div>
            <div style={{ width: "100%" }}>
              <LoaderSkeleton count={4} height={200} gridView />

              <LoaderSkeleton count={3} height={200} gridView />
            </div>

          </div>
          <LoaderSkeleton count={4} height={200} gridView />
          <LoaderSkeleton count={6} height={200} gridView />
        </div>
        <div className="m-b-20">
          <div className={styles.heading}>
            <LoaderSkeleton />
          </div>
          <LoaderSkeleton height={170} count={6} gridView />
        </div>

        <div className="m-b-40">
          <LoaderSkeleton height={560} />
        </div>
        <div className="m-b-40">
          <LoaderSkeleton className="m-b-20" />
          <LoaderSkeleton height={338} count={4} gridView />
        </div>

        <div className="d-flex m-b-40" style={{ gap: "calc(5 * var(--safari-root-font, 10px))" }}>
          <div style={{ width: "30%" }}>
            <LoaderSkeleton height={414} />
          </div>
          <div style={{ width: "70%" }}>
            <LoaderSkeleton count={4} gridView height={414} />
          </div>

        </div>

        <div className="m-b-40">
          <div className={styles.heading}>
            <LoaderSkeleton />
          </div>
          <LoaderSkeleton height={45} count={20} className="m-b-20" gridView />
          <LoaderSkeleton height={154} count={10} gridView />
        </div>

        <div className="m-b-40">
          <div className={styles.heading}>
            <LoaderSkeleton />
          </div>
          <LoaderSkeleton height={85} count={6} className="m-b-10" gridView />
          <LoaderSkeleton height={85} count={6} gridView />
        </div>

      </div>

    </>

  );
}

export default memo(HomePagePlaceHolder);
